import React from 'react'
import { Typography, Modal, Button, Row, Col, Icon } from 'antd'
import IframeFile from '../IframeFile'

const { Text, Title } = Typography
class ModalshowAllImage extends React.PureComponent {

    state = {
		dataImages: [],
        removeKey: []
	}

    onDelect = async (keys, name) =>{
        const { dataArrayId, destroyArrayDataImages } = this.props
        const { removeKey } = this.state


        // removeKey.push(keys)

        document.getElementById('block_show_'+keys).remove();

        destroyArrayDataImages(dataArrayId, name)
    }

    hideModal = () =>{
        const { hideModal, destroyArrayDataImages, dataArrayId } = this.props
        const { removeKey } = this.state

        
        console.log(dataArrayId.sort)
        // destroyArrayDataImages(dataArrayId, removeKey)
        // hideModal()
    }

    onClickToNewTab = (keys, typeFile) =>{
        // var win = window.open();
        var win = window.open();
        if(typeFile == 'pdf'){
            var output = document.getElementById('show_iframe_'+keys);
            win.document.write('<iframe src="' + output.src  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        }else{
            var output = document.getElementById('show_images_'+keys);
            console.log('output',output.src)
            win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' + output.src  + '" style="max-width:100%; height:auto"/></div>');
        }
    }

    onViewImages = (typeFile, file) =>{
        var win = window.open();
        win.document.write('<div style="margin:0 auto; width:900px;" align="center"><img src="'+'data:'+typeFile+';base64,'+file+'" style="max-width:100%; height:auto"/></div>');
    }


    bodyHtmlfileDatabase = (dataFile) => {
        return <>
                    <Row  gutter={16} type="flex" justify="left" align="top" >
                        {
                            dataFile.map((values, keys) =>{
                                if(values){
                                    return  <>
                                                <Col span={8} className="mb-3" id={"block_show_"+keys} style={{ display:"block"}}>
                                                    {
                                                        values.fileMimeType !== "application/pdf" ? 
                                                            <>  
                                                                <div style={{ width:"100%", height: "200px", padding:"10px 55px" }} align="center" className="block-show-image-modal">
                                                                    {/* <img src={'data:'+values.fileMimeType+';base64,'+values.fileId}  style={{ width:"200px", height:"180px"}}  id={"show_images_"+keys}/> */}
                                                                    <div 
                                                                        className="background-popup-div" 
                                                                        style={{ backgroundImage: `url(data:${values.fileMimeType};base64,${values.fileId})`}}
                                                                    >
                                                                    </div>
                                                                    <a 
                                                                        title='ดูรูปภาพ' 
                                                                        // className="mt-3 color-red" 
                                                                        className="icons-delect-images"
                                                                        target="_blank" 
                                                                        onClick={ () => this.onViewImages(values.fileMimeType, values.fileId) } 
                                                                    >
                                                                        <Icon type="eye" style={{ color:"#fff" }}/>
                                                                    </a>
                                                                </div>
                                                            </>
                                                        :
                                                            <>
                                                                <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
                                                                    <IframeFile typeFile={values.fileMimeType}  file={values.fileId} showPdfFild={true}/>
                                                                </div>
                                                            </>
                                                    }
                                                </Col>
                                            </>
                                }
                            })
                        }
                    </Row>
                </>
    }

    bodyHtmlfile = (dataFile) => {
        return <>
                    <Row  gutter={16} type="flex" justify="left" align="top" >
                        {
                            dataFile.map((values, keys) =>{
                                if(values){
                                    return  <>
                                                <Col span={8} className="mb-3" id={"block_show_"+keys} style={{ display:"block"}}>
                                                    {
                                                        values.type !== "application/pdf" ? 
                                                            <>  
                                                                <div style={{ width:"100%", height: "200px", padding:"10px 55px" }} align="center" className="block-show-image-modal">
                                                                    <img style={{  height:"100%"}} id={"show_images_"+keys}/>
                                                                    <a onClick={()=> this.onClickToNewTab(keys, "img")} className="icons-show-images">
                                                                        <Icon type="eye" style={{ color:"#fff" }}/>
                                                                    </a>
                                                                    <a onClick={()=> this.onDelect(keys, values.name)} className="icons-delect-images">
                                                                        <Icon type="delete" style={{ color:"#fff", fontSize:"20px" }}/>
                                                                    </a>
                                                                </div>
                                                            </>
                                                        :
                                                            <>
                                                                <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
                                                                    <iframe id={'show_iframe_'+keys} style={{ opacity:"0", height:"0" }} style={{ display:"none" }}></iframe>
                                                                    <a onClick={()=> this.onClickToNewTab(keys, 'pdf')} className="color-white">
                                                                        <Icon type="file-pdf" /><br></br>
                                                                        ดูไฟล์ PDF
                                                                    </a><br></br> 
                                                                    <a onClick={()=> this.onDelect(keys, values.name)} className="icons-delect-images">
                                                                        <Icon type="delete" style={{ color:"#fff", fontSize:"20px" }}/>
                                                                    </a>
                                                                </div>
                                                            </>
                                                    }
                                                </Col>
                                            </>
                                }
                            })
                        }
                    </Row>
                </>
    }

    modalShowFileCreate = (dataFile) =>{
        if(dataFile.length !== 0){
            return dataFile.map((values, keys) =>{
                // console.log('values',values)
                if(values){
                    var url = URL.createObjectURL(values)
                    const reader = new FileReader();
                    let linkNewTab = null
                    if(values.type !== "application/pdf"){
                        reader.readAsDataURL(values)
                        reader.onloadend = async (e) => {
                            var dataURL = reader.result;
                            var output = document.getElementById('show_images_'+keys);
                            output.src = dataURL;
                            // linkNewTab = dataURL
                            // await this.setState({
                            //     linkNewTab: dataURL
                            // })
                        };
                    }else{
                        reader.readAsDataURL(values)
                        reader.onloadend = async (e) => {
                            var dataURL = reader.result;
                            var output = document.getElementById('show_iframe_'+keys);
                            output.src = dataURL;
                            // output.href = dataURL;
                            // linkNewTab = dataURL
                            // await this.setState({
                            //     linkNewTab: dataURL
                            // })
                            // return <iframe href={dataURL} style={{ width:"100%", height:"500px" }}></iframe>
                        };
                    }
                }
            })
        }
        
    }

	async componentDidMount() {
        const { title, subtitle, showModal, data, hideModal } = this.props
        await this.setState({
            dataImages: data
        })
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
		const { data } = this.props
        const { dataImages } = this.state

		if (prevProps.data.length !== data.length) {
            await this.setState({
                dataImages: data
            })
		}
	}

	render() {
        const { title, subtitle, showModal, data, hideModal, imageDatabase } = this.props
        const { dataImages } = this.state

        console.log('asdfasf',data)
		return (
			<>
				<Modal
                    destroyOnClose={true}
                    maskClosable={false}
					visible={showModal}
					title={title}
					// title="ไฟล์อัปโหลดรูปใบเสร็จ"
					onOk={ hideModal }
					onCancel={ hideModal }
					width={1200}
					footer={null}
                    >
                        {
                            imageDatabase ?
                                <>
                                    {  this.bodyHtmlfileDatabase(data) }
                                </>
                            :
                            <>
                                {  this.bodyHtmlfile(data) }
                                {  this.modalShowFileCreate(data) }
                            </>
                        }
                        
				</Modal>
			</>
		)
	}
}

export default ModalshowAllImage